import React from 'react';
import { motion } from 'framer-motion';
export function Slide6() {
  const items = ['More engaging', 'More scalable', 'Measurable'];
  return <div className="slide-content flex flex-col items-center justify-center text-center" data-id="element-124">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="mb-16" data-id="element-125">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-8" data-id="element-126">
          You're already doing the work.
        </h1>
      </motion.div>

      <div className="flex flex-col items-start text-left mb-24" data-id="element-127">
        <motion.p className="text-3xl text-text-muted mb-8 font-medium" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-128">
          We make it:
        </motion.p>

        <div className="space-y-6 ml-8" data-id="element-129">
          {items.map((item, index) => <motion.div key={index} className="flex items-center text-4xl font-bold" initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 1 + index * 0.2
        }} data-id="element-130">
              <span className="text-roche-red mr-6" data-id="element-131">→</span>
              {item}
            </motion.div>)}
        </div>
      </div>

      <motion.div className="text-3xl md:text-4xl font-bold text-roche-red mt-auto pb-12" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 1,
      delay: 2.2
    }} data-id="element-132">
        From content <span className="text-text-main opacity-30 mx-3" data-id="element-133">→</span>
        to conversations{' '}
        <span className="text-text-main opacity-30 mx-3" data-id="element-134">→</span>
        to continuous learning.
      </motion.div>
    </div>;
}